import { FC } from 'react';
import { BreadcrumbList, LocalBusiness, FAQPage, Blog } from 'schema-dts';

interface StructuredDataProps {
  breadcrumbs?: Array<{
    position: number;
    name: string;
    item: string;
  }>;
  localBusiness?: {
    name: string;
    address: {
      streetAddress: string;
      addressLocality: string;
      addressRegion: string;
      postalCode: string;
    };
    telephone: string;
    rating?: number;
    reviewCount?: number;
  };
  faq?: Array<{
    question: string;
    answer: string;
  }>;
  blogSchema?: {
    "@context": string;
    "@type": string;
    name: string;
    description: string;
    url: string;
    blogPost: Array<{
      "@type": string;
      headline: string;
      description: string;
      datePublished: string;
      image: string;
      url: string;
      keywords: string;
    }>;
  };
}

export const StructuredData: FC<StructuredDataProps> = ({
  breadcrumbs,
  localBusiness,
  faq,
  blogSchema
}) => {
  return (
    <>
      {breadcrumbs && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: breadcrumbs.map(item => ({
                '@type': 'ListItem',
                position: item.position,
                name: item.name,
                item: item.item
              }))
            } as BreadcrumbList)
          }}
        />
      )}

      {localBusiness && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'LocalBusiness',
              name: localBusiness.name,
              address: {
                '@type': 'PostalAddress',
                ...localBusiness.address
              },
              telephone: localBusiness.telephone,
              ...(localBusiness.rating && localBusiness.reviewCount ? {
                aggregateRating: {
                  '@type': 'AggregateRating',
                  ratingValue: localBusiness.rating,
                  reviewCount: localBusiness.reviewCount
                }
              } : {})
            } as LocalBusiness)
          }}
        />
      )}

      {faq && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faq.map(item => ({
                '@type': 'Question',
                name: item.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: item.answer
                }
              }))
            } as FAQPage)
          }}
        />
      )}

      {blogSchema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(blogSchema as Blog)
          }}
        />
      )}
    </>
  );
}; 